"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("./consts");
const clone_1 = require("./packages/clone");
const clone_deep_1 = require("./packages/clone_deep");
const diff_1 = require("./packages/diff");
const is_equal_1 = require("./packages/is_equal");
const is_native_1 = require("./packages/is_native");
const is_plain_object_1 = require("./packages/is_plain_object");
/* UTILS */
const Utils = {
    clone: clone_1.default,
    cloneDeep: clone_deep_1.default,
    diff: diff_1.default,
    isEqual: is_equal_1.default,
    isNative: is_native_1.default,
    isPlainObject: is_plain_object_1.default,
    isValueUnproxiable: (x) => {
        if (x === null)
            return true;
        const type = typeof x;
        if (type !== 'object' && type !== 'function')
            return true;
        const { constructor } = x;
        return consts_1.CONSTRUCTORS_IMMUTABLE.has(constructor) || (!consts_1.CONSTRUCTORS_SUPPORTED.has(constructor) && (consts_1.CONSTRUCTORS_UNSUPPORTED.has(constructor) || !is_native_1.default(constructor)));
    },
    isStrictlyImmutableMethod: (method) => {
        return consts_1.STRICTLY_IMMUTABLE_METHODS.has(method.name);
    },
    isLooselyImmutableArrayMethod: (method) => {
        return consts_1.LOOSELY_IMMUTABLE_METHODS.array.has(method.name);
    }
};
/* EXPORT */
exports.default = Utils;
